<template>
  <div class="welcome">
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Welcome',
  computed: {
    ...mapState(['openid', 'headPortrait', 'nickname'])
  },
  created () {
    var url = decodeURIComponent(window.location.href)
    if (url.indexOf('?') !== -1) {
      var str = url.substr()
      var strs = str.split('?')
      for (var i = 0; i < strs.length; i++) {
        var dataObj = strs[i].split('=')[1]
      }
      var jsonObj = JSON.parse(dataObj)
      console.log(jsonObj)
      let openid = jsonObj.openid
      let headimgurl = jsonObj.headimgurl
      let nickname = jsonObj.nickname
      // localStorage.setItem('openid', openid)
      // 存放openid
      this.changeArgs({openid: openid, headPortrait: headimgurl, nickname: nickname})

      // 验证是否有openid, 当前微信是否登录过账号
      console.log(this.openid)
      if (this.openid === '') {
        this.$router.push({name: 'Login'})
      } else {
        this.$router.push({name: 'Index'})
      }
    }
  },
  methods: {
    ...mapMutations(['changeArgs'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login/Welcome.vue